import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Privacy() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-489">Política de Privacidad</h1>
        <p className="muted" data-id="element-490">Última actualización: 29 de mayo de 2026</p>

        <h2 data-id="element-491">1. Quiénes somos</h2>
        <p data-id="element-492">
          Lipo Laser · Dermaclinic Beverly Hills ("nosotros", "nuestro") opera
          el sitio web lipolaserbeverlyhills.com (el "Sitio"). Nos comprometemos
          a proteger su privacidad y la información personal que comparte con
          nosotros.
        </p>

        <h2 data-id="element-493">2. Información que recopilamos</h2>
        <p data-id="element-494">Cuando interactúa con nuestro Sitio, podemos recopilar:</p>
        <ul data-id="element-495">
          <li data-id="element-496">
            <strong data-id="element-497">Información que usted proporciona:</strong> nombre,
            apellido, correo electrónico, número de teléfono, ciudad y
            preferencias de contacto cuando completa nuestro formulario de
            consulta privada.
          </li>
          <li data-id="element-498">
            <strong data-id="element-499">Información automática:</strong> dirección IP, tipo de
            navegador, dispositivo, páginas visitadas, tiempo de permanencia,
            fuente de tráfico.
          </li>
          <li data-id="element-500">
            <strong data-id="element-501">Cookies y tecnologías similares:</strong> utilizamos cookies
            y el Meta Pixel para mejorar su experiencia, medir el rendimiento
            del sitio y personalizar la publicidad.
          </li>
        </ul>

        <h2 data-id="element-502">3. Cómo usamos su información</h2>
        <ul data-id="element-503">
          <li data-id="element-504">Responder a su solicitud de consulta privada.</li>
          <li data-id="element-505">Proporcionarle información sobre nuestros servicios.</li>
          <li data-id="element-506">Mejorar la experiencia del sitio y nuestros servicios.</li>
          <li data-id="element-507">Cumplir con obligaciones legales.</li>
          <li data-id="element-508">
            Enviar comunicaciones de marketing (solo con su consentimiento
            expreso).
          </li>
          <li data-id="element-509">
            Medir el rendimiento de campañas publicitarias en Meta
            (Facebook/Instagram), Google y otras plataformas.
          </li>
        </ul>

        <h2 data-id="element-510">4. Compartir información con terceros</h2>
        <p data-id="element-511">
          No vendemos su información personal. Compartimos información limitada
          con:
        </p>
        <ul data-id="element-512">
          <li data-id="element-513">
            <strong data-id="element-514">Proveedores de servicios</strong> que nos ayudan a operar
            (GoHighLevel para CRM, Meta para publicidad).
          </li>
          <li data-id="element-515">
            <strong data-id="element-516">Autoridades</strong> cuando lo exija la ley.
          </li>
        </ul>

        <h2 data-id="element-517">5. Meta Pixel y publicidad</h2>
        <p data-id="element-518">
          Utilizamos Meta Pixel para medir la efectividad de nuestras campañas
          publicitarias en Facebook e Instagram. Esta tecnología puede recopilar
          información sobre sus visitas a nuestro sitio. Puede gestionar sus
          preferencias de publicidad en{' '}
          <a href="https://www.facebook.com/settings?tab=ads" target="_blank" rel="noopener noreferrer" data-id="element-519">
            configuración de anuncios de Facebook
          </a>
          .
        </p>

        <h2 data-id="element-520">6. Sus derechos</h2>
        <p data-id="element-521">Usted tiene derecho a:</p>
        <ul data-id="element-522">
          <li data-id="element-523">Acceder a la información personal que tenemos sobre usted.</li>
          <li data-id="element-524">Solicitar la corrección o eliminación de su información.</li>
          <li data-id="element-525">Retirar el consentimiento de marketing en cualquier momento.</li>
          <li data-id="element-526">Presentar una queja ante autoridades de protección de datos.</li>
        </ul>

        <h2 data-id="element-527">7. Residentes de California (CCPA)</h2>
        <p data-id="element-528">
          Bajo la Ley de Privacidad del Consumidor de California (CCPA), tiene
          derechos adicionales, incluyendo el derecho a saber qué información
          recopilamos, el derecho a eliminarla y el derecho a no ser
          discriminado por ejercer estos derechos.
        </p>

        <h2 data-id="element-529">8. Seguridad</h2>
        <p data-id="element-530">
          Implementamos medidas técnicas y organizativas razonables para
          proteger su información. Sin embargo, ninguna transmisión por internet
          es 100% segura.
        </p>

        <h2 data-id="element-531">9. Información médica (HIPAA)</h2>
        <p data-id="element-532">
          Lipo Laser · Dermaclinic Beverly Hills cumple con la Ley de
          Portabilidad y Responsabilidad del Seguro de Salud (HIPAA) en todo el
          manejo de información médica protegida (PHI). La información
          proporcionada en el formulario de contacto no se considera información
          médica protegida hasta que se establezca una relación médico-paciente
          formal.
        </p>

        <h2 data-id="element-533">10. Cambios a esta política</h2>
        <p data-id="element-534">
          Podemos actualizar esta política. La fecha de "última actualización"
          al inicio refleja la versión más reciente.
        </p>

        <h2 data-id="element-535">11. Contacto</h2>
        <p data-id="element-536">
          Si tiene preguntas sobre esta política, contáctenos en:{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-537">
            hello@lipolaserbeverlyhills.com
          </a>
        </p>
      </> : <>
        <h1 data-id="element-538">Privacy Policy</h1>
        <p className="muted" data-id="element-539">Last updated: May 29, 2026</p>

        <h2 data-id="element-540">1. Who we are</h2>
        <p data-id="element-541">
          Lipo Laser · Dermaclinic Beverly Hills ("we", "us", "our") operates
          lipolaserbeverlyhills.com (the "Site"). We are committed to protecting
          your privacy and the personal information you share with us.
        </p>

        <h2 data-id="element-542">2. Information we collect</h2>
        <p data-id="element-543">When you interact with our Site, we may collect:</p>
        <ul data-id="element-544">
          <li data-id="element-545">
            <strong data-id="element-546">Information you provide:</strong> first name, last name,
            email, phone number, city, and contact preferences when you complete
            our private consultation form.
          </li>
          <li data-id="element-547">
            <strong data-id="element-548">Automatic information:</strong> IP address, browser type,
            device, pages visited, time spent, traffic source.
          </li>
          <li data-id="element-549">
            <strong data-id="element-550">Cookies and similar technologies:</strong> we use cookies
            and the Meta Pixel to improve your experience, measure site
            performance, and personalize advertising.
          </li>
        </ul>

        <h2 data-id="element-551">3. How we use your information</h2>
        <ul data-id="element-552">
          <li data-id="element-553">Respond to your private consultation request.</li>
          <li data-id="element-554">Provide information about our services.</li>
          <li data-id="element-555">Improve site experience and services.</li>
          <li data-id="element-556">Comply with legal obligations.</li>
          <li data-id="element-557">
            Send marketing communications (only with your express consent).
          </li>
          <li data-id="element-558">
            Measure performance of advertising campaigns on Meta
            (Facebook/Instagram), Google, and other platforms.
          </li>
        </ul>

        <h2 data-id="element-559">4. Sharing with third parties</h2>
        <p data-id="element-560">
          We do not sell your personal information. We share limited information
          with:
        </p>
        <ul data-id="element-561">
          <li data-id="element-562">
            <strong data-id="element-563">Service providers</strong> who help us operate (GoHighLevel
            for CRM, Meta for advertising).
          </li>
          <li data-id="element-564">
            <strong data-id="element-565">Authorities</strong> when required by law.
          </li>
        </ul>

        <h2 data-id="element-566">5. Meta Pixel and advertising</h2>
        <p data-id="element-567">
          We use the Meta Pixel to measure the effectiveness of our advertising
          campaigns on Facebook and Instagram. This technology may collect
          information about your visits to our site. You can manage your
          advertising preferences in{' '}
          <a href="https://www.facebook.com/settings?tab=ads" target="_blank" rel="noopener noreferrer" data-id="element-568">
            Facebook ad settings
          </a>
          .
        </p>

        <h2 data-id="element-569">6. Your rights</h2>
        <p data-id="element-570">You have the right to:</p>
        <ul data-id="element-571">
          <li data-id="element-572">Access the personal information we hold about you.</li>
          <li data-id="element-573">Request correction or deletion of your information.</li>
          <li data-id="element-574">Withdraw marketing consent at any time.</li>
          <li data-id="element-575">File a complaint with data protection authorities.</li>
        </ul>

        <h2 data-id="element-576">7. California Residents (CCPA)</h2>
        <p data-id="element-577">
          Under the California Consumer Privacy Act (CCPA), you have additional
          rights including the right to know what information we collect, the
          right to delete it, and the right not to be discriminated against for
          exercising these rights.
        </p>

        <h2 data-id="element-578">8. Security</h2>
        <p data-id="element-579">
          We implement reasonable technical and organizational measures to
          protect your information. However, no internet transmission is 100%
          secure.
        </p>

        <h2 data-id="element-580">9. Medical information (HIPAA)</h2>
        <p data-id="element-581">
          Lipo Laser · Dermaclinic Beverly Hills complies with the Health
          Insurance Portability and Accountability Act (HIPAA) in handling all
          Protected Health Information (PHI). Information provided in the
          contact form is not considered protected health information until a
          formal physician-patient relationship is established.
        </p>

        <h2 data-id="element-582">10. Changes to this policy</h2>
        <p data-id="element-583">
          We may update this policy. The "last updated" date at the top reflects
          the most recent version.
        </p>

        <h2 data-id="element-584">11. Contact</h2>
        <p data-id="element-585">
          If you have questions about this policy, contact us at:{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-586">
            hello@lipolaserbeverlyhills.com
          </a>
        </p>
      </>;
  return <LegalLayout data-id="element-587">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-588">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-589">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-590">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-591">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-592">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-593">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-594" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-595">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-596">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-597">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-598">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}